/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalPaymentInvoice } from '../models/ExternalPaymentInvoice';
import type { Invoice } from '../models/Invoice';
import type { InvoiceRetry } from '../models/InvoiceRetry';
import type { PaginatedInvoiceList } from '../models/PaginatedInvoiceList';
import type { PartialRefund } from '../models/PartialRefund';
import type { PatchedInvoice } from '../models/PatchedInvoice';
import type { PrepaidRefund } from '../models/PrepaidRefund';
import type { UserAddress } from '../models/UserAddress';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InvoiceEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns PaginatedInvoiceList
   * @throws ApiError
   */
  public invoiceList({
    bookedTrainingIds,
    excludeType,
    hasTriedSpendingPrepaidCredits,
    issuerCompanyDrivingSchoolId,
    limit,
    offset,
    ordering,
    prepaidType,
    recipientFirebaseAuthUsersId,
    recipientId,
    recipientCompanyDrivingSchoolId,
    showDisputeFees,
    state,
    type,
  }: {
    bookedTrainingIds?: string,
    /**
     * * `PREPAID_CREDITS` - PREPAID_CREDITS
     * * `DRIVING_LESSON_INVOICE` - DRIVING_LESSON_INVOICE
     * * `REMOTE_LESSON` - REMOTE_LESSON
     * * `THEORY_LESSON` - THEORY_LESSON
     * * `AUTHORITY_FEE` - AUTHORITY_FEE
     * * `CREDIT_NOTE` - CREDIT_NOTE
     * * `TEACHING_MATERIAL` - TEACHING_MATERIAL
     * * `BASE_FEE` - BASE_FEE
     * * `B2B` - B2B
     * * `LEGACY_B2B` - LEGACY_B2B
     * * `LEGACY_B2C` - LEGACY_B2C
     * * `VR_EQUIPMENT_FEE` - VR_EQUIPMENT_FEE
     * * `BASE_FEE_ADDITION` - BASE_FEE_ADDITION
     * * `MISCELLANEOUS` - MISCELLANEOUS
     * * `PAYOUT_ADVANCE_RECEIPT` - PAYOUT_ADVANCE_RECEIPT
     * * `B2B_PAYOUT_ADVANCE_RECEIPT` - B2B_PAYOUT_ADVANCE_RECEIPT
     * * `ASF_COURSE_FEE` - ASF_COURSE_FEE
     * * `THEORY_REFRESHER` - THEORY_REFRESHER
     * * `THEORY_PRE_EXAM` - THEORY_PRE_EXAM
     * * `APPLICATION_SERVICE` - APPLICATION_SERVICE
     * * `AUTOVIO_SUBSCRIPTION` - AUTOVIO_SUBSCRIPTION
     * * `RECEIPT_B2B` - RECEIPT_B2B
     * * `MANUAL_REFUND_TRANSFER` - MANUAL_REFUND_TRANSFER
     * * `EXTERNAL_SERVICE` - EXTERNAL_SERVICE
     */
    excludeType?: Array<'APPLICATION_SERVICE' | 'ASF_COURSE_FEE' | 'AUTHORITY_FEE' | 'AUTOVIO_SUBSCRIPTION' | 'B2B' | 'B2B_PAYOUT_ADVANCE_RECEIPT' | 'BASE_FEE' | 'BASE_FEE_ADDITION' | 'CREDIT_NOTE' | 'DRIVING_LESSON_INVOICE' | 'EXTERNAL_SERVICE' | 'LEGACY_B2B' | 'LEGACY_B2C' | 'MANUAL_REFUND_TRANSFER' | 'MISCELLANEOUS' | 'PAYOUT_ADVANCE_RECEIPT' | 'PREPAID_CREDITS' | 'RECEIPT_B2B' | 'REMOTE_LESSON' | 'TEACHING_MATERIAL' | 'THEORY_LESSON' | 'THEORY_PRE_EXAM' | 'THEORY_REFRESHER' | 'VR_EQUIPMENT_FEE'>,
    hasTriedSpendingPrepaidCredits?: boolean,
    issuerCompanyDrivingSchoolId?: string,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string,
    /**
     * * `STRIPE` - STRIPE
     * * `CASH` - CASH
     * * `EXTERNAL_BANK_TRANSFER` - EXTERNAL_BANK_TRANSFER
     */
    prepaidType?: 'CASH' | 'EXTERNAL_BANK_TRANSFER' | 'STRIPE',
    recipientFirebaseAuthUsersId?: string,
    recipientId?: string,
    recipientCompanyDrivingSchoolId?: string,
    showDisputeFees?: boolean,
    /**
     * * `NEW` - NEW
     * * `HAS_BASE_DATA` - HAS_BASE_DATA
     * * `HAS_BRANCH_ADDRESS` - HAS_BRANCH_ADDRESS
     * * `HAS_POSITIONS` - HAS_POSITIONS
     * * `WAITING_FOR_MANUAL_CHECK` - WAITING_FOR_MANUAL_CHECK
     * * `HAS_RECIPIENT_ADDRESS` - HAS_RECIPIENT_ADDRESS
     * * `HAS_PASSED_CHECKS_BEFORE_ISSUING` - HAS_PASSED_PRE_CHECKS
     * * `ERROR_HAS_NO_SEPA_BANK_ACCOUNT` - ERROR_HAS_NO_SEPA_BANK_ACCOUNT
     * * `WAITING_FOR_BALANCE_TRANSACTION_AVAILABLE` - WAITING_FOR_BALANCE_TRANSACTION_AVAILABLE
     * * `IS_REAL_INVOICE` - IS_REAL_INVOICE
     * * `HAS_CREDITS_APPLIED` - HAS_CREDITS_APPLIED
     * * `HAS_FREE_CREDITS_APPLIED` - HAS_FREE_CREDITS_APPLIED
     * * `HAS_START_CREDITS_APPLIED` - HAS_START_CREDITS_APPLIED
     * * `HAS_COMPENSATION_APPLIED` - HAS_COMPENSATION_APPLIED
     * * `HAS_PREPAID_CREDITS_APPLIED` - HAS_PREPAID_CREDITS_APPLIED
     * * `ERROR_HAS_NO_ADDRESS` - ERROR_HAS_NO_ADDRESS
     * * `HAS_CALCULATION_NUMBER` - HAS_CALCULATION_NUMBER
     * * `B2B_INVOICING_CHECKED` - B2B_INVOICING_CHECKED
     * * `WAITING_FOR_B2B_TRANSFER` - WAITING_FOR_B2B_TRANSFER
     * * `WAITING_FOR_B2B_STRIPE_PAYMENT` - WAITING_FOR_B2B_STRIPE_PAYMENT
     * * `B2B_STRIPE_PAYMENT_FAILED` - B2B_STRIPE_PAYMENT_FAILED
     * * `B2B_MARKED_FOR_PARTIAL_REFUND` - B2B_MARKED_FOR_PARTIAL_REFUND
     * * `PDF_RENDERED` - PDF_RENDERED
     * * `UNPAID` - UNPAID
     * * `PARTIALLY_PAID` - PARTIALLY_PAID
     * * `UNPAID_WITH_PREPAID_CREDITS` - UNPAID_WITH_PREPAID_CREDITS
     * * `AWAITING_PAYMENT` - AWAITING_PAYMENT
     * * `PAID` - PAID
     * * `PAYMENT_REVOKED` - PAYMENT_REVOKED
     * * `REFUNDED` - REFUNDED
     * * `PARTIALLY_REFUNDED` - PARTIALLY_REFUNDED
     * * `UNKNOWN_FROM_MIGRATION` - UNKNOWN_FROM_MIGRATION
     * * `WAITING_FOR_PRE_INVOICE_PAYMENT` - WAITING_FOR_PRE_INVOICE_PAYMENT
     * * `WAITING_FOR_CUSTOMER_CONFIRMATION` - WAITING_FOR_CUSTOMER_CONFIRMATION
     * * `PREPAID_CREDITS_AVAILABLE` - PREPAID_CREDITS_AVAILABLE
     * * `CANCELED` - CANCELED
     * * `PRE_INVOICE_PAYMENT_SUCCESSFUL` - PRE_INVOICE_PAYMENT_SUCCESSFUL
     * * `TO_BE_MANUALLY_REFUNDED` - TO_BE_MANUALLY_REFUNDED
     * * `NEEDS_RECIPIENT_ADDRESS` - NEEDS_RECIPIENT_ADDRESS
     */
    state?: 'AWAITING_PAYMENT' | 'B2B_INVOICING_CHECKED' | 'B2B_MARKED_FOR_PARTIAL_REFUND' | 'B2B_STRIPE_PAYMENT_FAILED' | 'CANCELED' | 'ERROR_HAS_NO_ADDRESS' | 'ERROR_HAS_NO_SEPA_BANK_ACCOUNT' | 'HAS_BASE_DATA' | 'HAS_BRANCH_ADDRESS' | 'HAS_CALCULATION_NUMBER' | 'HAS_COMPENSATION_APPLIED' | 'HAS_CREDITS_APPLIED' | 'HAS_FREE_CREDITS_APPLIED' | 'HAS_PASSED_CHECKS_BEFORE_ISSUING' | 'HAS_POSITIONS' | 'HAS_PREPAID_CREDITS_APPLIED' | 'HAS_RECIPIENT_ADDRESS' | 'HAS_START_CREDITS_APPLIED' | 'IS_REAL_INVOICE' | 'NEEDS_RECIPIENT_ADDRESS' | 'NEW' | 'PAID' | 'PARTIALLY_PAID' | 'PARTIALLY_REFUNDED' | 'PAYMENT_REVOKED' | 'PDF_RENDERED' | 'PREPAID_CREDITS_AVAILABLE' | 'PRE_INVOICE_PAYMENT_SUCCESSFUL' | 'REFUNDED' | 'TO_BE_MANUALLY_REFUNDED' | 'UNKNOWN_FROM_MIGRATION' | 'UNPAID' | 'UNPAID_WITH_PREPAID_CREDITS' | 'WAITING_FOR_B2B_STRIPE_PAYMENT' | 'WAITING_FOR_B2B_TRANSFER' | 'WAITING_FOR_BALANCE_TRANSACTION_AVAILABLE' | 'WAITING_FOR_CUSTOMER_CONFIRMATION' | 'WAITING_FOR_MANUAL_CHECK' | 'WAITING_FOR_PRE_INVOICE_PAYMENT',
    /**
     * * `PREPAID_CREDITS` - PREPAID_CREDITS
     * * `DRIVING_LESSON_INVOICE` - DRIVING_LESSON_INVOICE
     * * `REMOTE_LESSON` - REMOTE_LESSON
     * * `THEORY_LESSON` - THEORY_LESSON
     * * `AUTHORITY_FEE` - AUTHORITY_FEE
     * * `CREDIT_NOTE` - CREDIT_NOTE
     * * `TEACHING_MATERIAL` - TEACHING_MATERIAL
     * * `BASE_FEE` - BASE_FEE
     * * `B2B` - B2B
     * * `LEGACY_B2B` - LEGACY_B2B
     * * `LEGACY_B2C` - LEGACY_B2C
     * * `VR_EQUIPMENT_FEE` - VR_EQUIPMENT_FEE
     * * `BASE_FEE_ADDITION` - BASE_FEE_ADDITION
     * * `MISCELLANEOUS` - MISCELLANEOUS
     * * `PAYOUT_ADVANCE_RECEIPT` - PAYOUT_ADVANCE_RECEIPT
     * * `B2B_PAYOUT_ADVANCE_RECEIPT` - B2B_PAYOUT_ADVANCE_RECEIPT
     * * `ASF_COURSE_FEE` - ASF_COURSE_FEE
     * * `THEORY_REFRESHER` - THEORY_REFRESHER
     * * `THEORY_PRE_EXAM` - THEORY_PRE_EXAM
     * * `APPLICATION_SERVICE` - APPLICATION_SERVICE
     * * `AUTOVIO_SUBSCRIPTION` - AUTOVIO_SUBSCRIPTION
     * * `RECEIPT_B2B` - B2B_RECEIPT
     * * `MANUAL_REFUND_TRANSFER` - MANUAL_REFUND_TRANSFER
     * * `EXTERNAL_SERVICE` - EXTERNAL_SERVICE
     */
    type?: 'APPLICATION_SERVICE' | 'ASF_COURSE_FEE' | 'AUTHORITY_FEE' | 'AUTOVIO_SUBSCRIPTION' | 'B2B' | 'B2B_PAYOUT_ADVANCE_RECEIPT' | 'BASE_FEE' | 'BASE_FEE_ADDITION' | 'CREDIT_NOTE' | 'DRIVING_LESSON_INVOICE' | 'EXTERNAL_SERVICE' | 'LEGACY_B2B' | 'LEGACY_B2C' | 'MANUAL_REFUND_TRANSFER' | 'MISCELLANEOUS' | 'PAYOUT_ADVANCE_RECEIPT' | 'PREPAID_CREDITS' | 'RECEIPT_B2B' | 'REMOTE_LESSON' | 'TEACHING_MATERIAL' | 'THEORY_LESSON' | 'THEORY_PRE_EXAM' | 'THEORY_REFRESHER' | 'VR_EQUIPMENT_FEE',
  }): CancelablePromise<PaginatedInvoiceList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice/',
      query: {
        'booked_training_ids': bookedTrainingIds,
        'exclude_type': excludeType,
        'has_tried_spending_prepaid_credits': hasTriedSpendingPrepaidCredits,
        'issuer_company__driving_school_id': issuerCompanyDrivingSchoolId,
        'limit': limit,
        'offset': offset,
        'ordering': ordering,
        'prepaid_type': prepaidType,
        'recipient__firebase_auth_users__id': recipientFirebaseAuthUsersId,
        'recipient__id': recipientId,
        'recipient_company__driving_school_id': recipientCompanyDrivingSchoolId,
        'show_dispute_fees': showDisputeFees,
        'state': state,
        'type': type,
      },
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Update only the booked_training_id field of an invoice.
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody: Invoice,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/invoice/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoicePartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody?: PatchedInvoice,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/invoice/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceRefundCreate({
    id,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/{id}/refund/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceRefundPartiallyCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody: PartialRefund,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/{id}/refund-partially/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PrepaidRefund
   * @throws ApiError
   */
  public invoiceRefundPrepaidCreditsRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
  }): CancelablePromise<PrepaidRefund> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice/{id}/refund-prepaid-credits/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceRefundPrepaidCreditsCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody: PartialRefund,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/{id}/refund-prepaid-credits/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceRetryPaymentCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody?: InvoiceRetry,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/{id}/retry-payment/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceUpdateAddressOnPdfCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
    requestBody: UserAddress,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/{id}/update-address-on-pdf/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceCreateCashPaymentInvoiceCreate({
    requestBody,
  }: {
    requestBody: ExternalPaymentInvoice,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/create-cash-payment-invoice/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Invoice
   * @throws ApiError
   */
  public invoiceCreateExternalBankTransferPaymentInvoiceCreate({
    requestBody,
  }: {
    requestBody: ExternalPaymentInvoice,
  }): CancelablePromise<Invoice> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/invoice/create-external-bank-transfer-payment-invoice/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public invoiceIsProcessingRetrieve(): CancelablePromise<{
    processing: boolean;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice/is-processing/',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public invoiceManualInvoiceMetadataRetrieve(): CancelablePromise<{
    manual_invoice_type_descriptions: {
      TEACHING_MATERIAL_MANUAL: string;
      VR_EQUIPMENT_FEE: string;
      UPGRADE_TRAINING_PACKAGE: string;
      COACHING: string;
      ASF_COURSE_FEE: string;
      FES_COURSE_FEE: string;
      DRIVING_LESSON_CHARGE_LATER: string;
      AUTHORITY_FEE_MANUAL: string;
      REGISTRATION_FEES: string;
      CHANGE_FEES: string;
      TUEV_FEE_MANUAL: string;
      DEKRA_FEE_MANUAL: string;
      THEORY_TEST_MANUAL: string;
      PRACTICAL_TEST_MANUAL: string;
      THEORY_REFRESHER_MANUAL: string;
      THEORY_PRE_EXAM: string;
      APPLICATION_SERVICE: string;
      CONTRIBUTION_LEARNING_GROUP: string;
      LBV_FEE: string;
      AUTOVIO_SUBSCRIPTION_FEE: string;
      CONTINUATION_FEE: string;
      ACCESS_YAAK_APP: string;
      TRAINING_SITE_FEE: string;
      PICK_UP_SERVICE: string;
      CONTRACT_EXTENSION_3_MONTHS: string;
      CONTRACT_EXTENSION_6_MONTHS: string;
      RESCHEDULING_CAMP: string;
      EXTERNAL_SERVICE_TYPE: string;
    };
    manual_invoice_type_vat_percentages: {
      TEACHING_MATERIAL_MANUAL: number;
      VR_EQUIPMENT_FEE: number;
      UPGRADE_TRAINING_PACKAGE: number;
      COACHING: number;
      ASF_COURSE_FEE: number;
      FES_COURSE_FEE: number;
      DRIVING_LESSON_CHARGE_LATER: number;
      AUTHORITY_FEE_MANUAL: number;
      REGISTRATION_FEES: number;
      CHANGE_FEES: number;
      TUEV_FEE_MANUAL: number;
      DEKRA_FEE_MANUAL: number;
      THEORY_TEST_MANUAL: number;
      PRACTICAL_TEST_MANUAL: number;
      THEORY_REFRESHER_MANUAL: number;
      THEORY_PRE_EXAM: number;
      APPLICATION_SERVICE: number;
      CONTRIBUTION_LEARNING_GROUP: number;
      LBV_FEE: number;
      AUTOVIO_SUBSCRIPTION_FEE: number;
      CONTINUATION_FEE: number;
      ACCESS_YAAK_APP: number;
      TRAINING_SITE_FEE: number;
      PICK_UP_SERVICE: number;
      CONTRACT_EXTENSION_3_MONTHS: number;
      CONTRACT_EXTENSION_6_MONTHS: number;
      RESCHEDULING_CAMP: number;
      EXTERNAL_SERVICE_TYPE: number;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice/manual-invoice-metadata/',
    });
  }

}
